<template>
  <v-container>
    <div class="pb-5 pt-5 margin-left-12">
      <span>
        <h3>{{ userId ? "사용자 수정" : "사용자 추가" }}</h3>
      </span>
    </div>
    <v-card class="back-white pt-5  " height="750">
      <v-row class="pa-3 ml-5"> </v-row>
      <v-row align="center" class="pa-5 mb-5">
        <div class="width-200 ">
          <span class="pl-5 ma-1 ">이름</span>
          <span class=" required-text" v-if="!userId">(필수*)</span>
        </div>
        <div>
          <input
            class="border-aaaaaa width400-height38"
            v-model="userDataList.userName"
          />
        </div>
        <span class=" margin-left100 width-120">
          회사
        </span>
        <div class="mr-5">
          <input
            class="border-width"
            v-model="userDataList.companyName"
            disabled
          />
        </div>
        <div class="ml-5">
          <CompanyModal :companyType="userDataList.companyType" />
        </div>
      </v-row>
      <v-row align="center" class="pa-5 mb-5">
        <div class="width-200 ">
          <span class="pl-5 ma-1 ">아이디</span>
          <span class=" required-text" v-if="!userId">(필수*)</span>
        </div>
        <div>
          <v-text-field
            v-model="userDataList.accountName"
            @change="idCheck"
            class="align-center width400-height38"
            hide-details=""
            outlined
            height="38"
            dense
            :disabled="userId != undefined"
          >
            <v-icon slot="append" color="green" v-if="!userId && idDuplication"
              >mdi-check</v-icon
            >
            <v-icon slot="append" color="red" v-if="!userId && !idDuplication"
              >mdi-close</v-icon
            >
          </v-text-field>
        </div>
        <span class="margin-left100 width-120">
          현장
        </span>
        <div class="mr-5">
          <input class="border-width" v-model="selectConstListText" disabled />
        </div>
        <div class="ml-5">
          <ConstrucitonModal v-if="this.roleType != '현장관리자'" />
        </div>
      </v-row>
      <v-row align="center" class="pa-5 mb-5">
        <div class="width-200">
          <span class="pl-5 ma-1 ">비밀번호</span>
          <span class=" required-text" v-if="!userId">(필수*)</span>
        </div>
        <div>
          <input
            class="width400-height38 border-aaaaaa"
            v-model="userDataList.accountPassword"
            type="password"
            @change="checkPassWord"
          />
        </div>
        <div class="margin-left100 width-120">
          <span>전화번호</span>
          <span class="required-text" v-if="!userId">(필수*)</span>
        </div>

        <div>
          <input
            class="border-width"
            v-model="userDataList.phoneNumber"
            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
          />
        </div>
      </v-row>
      <v-row justify="center" align="center" class="pa-5 mb-5">
        <div class="width-200">
          <span class="pl-5 ma-1 ">비밀번호 확인</span>
          <span class=" required-text" v-if="!userId">(필수*)</span>
        </div>
        <div>
          <v-text-field
            v-model="userDataList.accountPasswordCheck"
            @change="checkPassWord"
            class="align-center width400-height38"
            hide-details=""
            outlined
            height="38"
            dense
            type="password"
          >
            <v-icon slot="append" color="green" v-if="!userId && passCheck"
              >mdi-check</v-icon
            >
            <v-icon slot="append" color="red" v-if="!userId && !passCheck"
              >mdi-close</v-icon
            >
          </v-text-field>
        </div>
        <v-spacer></v-spacer>
      </v-row>
      <v-row justify="center" align="center" class="padding-top50 ">
        <v-btn
          width="150"
          height="40"
          color="#739EEC"
          class="color-white mr-3"
          @click="updateUser"
        >
          등록완료
        </v-btn>
        <v-btn
          width="150"
          height="40"
          color="#ffffff"
          class="btn-ff5b5a mr-3"
          @click="deleteToUser"
          v-if="userId"
        >
          삭제
        </v-btn>
        <v-btn
          width="150"
          height="40"
          color="#eeeeee"
          @click="$router.push({ name: 'User' })"
        >
          뒤로가기
        </v-btn>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import CompanyModal from "./modal/Company";
import ConstrucitonModal from "./modal/Construction";
import UserApi from "@/api/UserService";
import ConstructionApi from "@/api/ConstructionService";
import Commonality from "@/mixin/Commonality";
export default {
  props: ["userId"],
  mixins: [Commonality],

  components: {
    CompanyModal,
    ConstrucitonModal,
  },

  async created() {
    if (this.userId) {
      let data = {
        userId: this.userId,
      };
      let retrunData = await UserApi.userInformaion(data);
      let result = retrunData.data.userInformation;
      let constData = await ConstructionApi.constructionListOnUser(data);
      let constResult = constData.data.constListonUser;
      let tempConstList = [];
      for (let i = 0; i < constResult.length; i++) {
        this.userDataList.companyList += constResult[i].constructionName;
        tempConstList.push(constResult[i].constructionId);
        this.selectConstListText += constResult[i].constructionName;
        if (constResult.length - 1 != i) this.selectConstListText += " / ";
      }
      this.userDataList.constIds = tempConstList;
      this.userDataList.accountName = result.accountName;
      this.userDataList.companyName = result.companyName;
      this.userDataList.companyType = result.companyType;
      this.userDataList.phoneNumber = result.phoneNumber;
      this.userDataList.roleType = result.roleType;
      this.userDataList.userName = result.userName;
      this.userDataList.companyId = result.companyId;
      this.userDataList.userId = result.userId;
    } else {
      if (this.roleType == "현장관리자") {
        this.userDataList.companyList = this.constructionName.constructionName;
        this.selectConstListText = this.constructionName.constructionName;
        this.userDataList.constIds = [this.constructionId];
      }
    }

    this.$bus.$on("sendCompany", (res) => {
      this.userDataList.companyName = res.companyName;
      this.userDataList.companyType = res.companyType;
      this.userDataList.companyId = res.companyId;
    });
    this.$bus.$on("sendConstruction", (res) => {
      let dataList = [];
      let tempText = "";
      for (let i = 0; i < res.length; i++) {
        tempText += res[i].constructionName;
        if (res.length - 1 != i) tempText += " / ";
        dataList.push(res[i].constructionId);
      }
      this.selectConstListText = tempText;
      this.userDataList.constIds = dataList;
    });
  },

  destroyed() {
    this.$bus.$off("sendCompany");
    this.$bus.$off("sendConstruction");
  },

  data: () => ({
    userDataList: {
      accountPassword: null,
      companyId: null,
      constIds: [],
      phoneNumber: "",
      userId: "",
      userName: "",
      accountName: "",
      roleType: "",
      accountPasswordCheck: "",
      companyType: "",
      companyList: "",
      companyIdList: [],
      companyName: "",
    },
    idDuplication: false,
    selectConstListText: "",
    passCheck: false,
    passText: "비밀번호 6글자 이상 입력해주세요.",
    idText: "아이디 6글자 이상 입력해주세요.",
    authState: ["관리자", "샵업체", "가공업체"],
    phoneNumberRegexList: [
      "032",
      "042",
      "051",
      "052",
      "053",
      "062",
      "064",
      "031",
      "033",
      "041",
      "043",
      "054",
      "055",
      "061",
      "063",
      "010",
      "011",
      "016",
      "017",
      "018",
      "019",
    ],
  }),

  methods: {
    checkPhoneNumber() {
      const myRegExp = /^[0-9]{10,11}/;

      return (
        myRegExp.test(this.userDataList.phoneNumber) &&
        this.userDataList.phoneNumber.length <= 11
      );
    },
    checkSD() {
      if (this.userDataList.phoneNumber.length < 2) return true;
      if (!this.checkPhoneNumber()) {
        this.$bus.$emit(
          "dialog",
          "전화번호 양식으로 입력해주세요.\n 예) 01012345678, 021234567"
        );
      }
      if (this.userDataList.phoneNumber.startsWith("02")) {
        if (
          this.userDataList.phoneNumber.length == 2 ||
          this.userDataList.phoneNumber.length == 7
        )
          this.userDataList.phoneNumber = this.userDataList.phoneNumber + "-";
        else if (this.userDataList.phoneNumber.length >= 12) {
          this.userDataList.phoneNumber = this.userDataList.phoneNumber.substring(
            0,
            11
          );
          this.$bus.$emit(
            "dialog",
            "전화번호 양식으로 입력해주세요.\n 예) 01012345678, 021234567"
          );
        }
        return true;
      }
      for (let i of this.phoneNumberRegexList) {
        if (this.userDataList.phoneNumber.startsWith(i)) {
          if (
            this.userDataList.phoneNumber.length == 3 ||
            this.userDataList.phoneNumber.length == 8
          )
            this.userDataList.phoneNumber = this.userDataList.phoneNumber + "-";
          else if (this.userDataList.phoneNumber.length >= 13) {
            this.userDataList.phoneNumber = this.userDataList.phoneNumber.substring(
              0,
              13
            );
            this.$bus.$emit(
              "dialog",
              "전화번호 양식으로 입력해주세요.\n 예) 01012345678, 021234567"
            );
          }
        }
      }
    },
    deleteToUser() {
      this.$bus.$emit("confirmOn", "user", this.userId);
    },
    async idCheck() {
      if (this.userId) return;
      if (this.userDataList.accountName.length < 6) {
        this.idText = "아이디 6글자 이상 입력해주세요.";
        this.idDuplication = false;
        return;
      }
      let sendData = { accountName: this.userDataList.accountName };
      let returnData = await UserApi.userIdDupplication(sendData);
      if (returnData.data.success == "fail") this.idDuplication = true;
      else {
        this.idText = "아이디가 중복입니다. 다른 아이디를 입력해주세요.";
        this.idDuplication = false;
      }
    },
    checkPassWord() {
      if (this.userDataList.accountPassword.length < 6) {
        this.passText = "비밀번호 6글자 이상 입력해주세요.";
        this.passCheck = false;
        return this.passCheck;
      }
      if (
        this.userDataList.accountPassword ==
        this.userDataList.accountPasswordCheck
      )
        this.passCheck = true;
      else {
        this.passText = "비밀번호와 비밀번호 확인이 다릅니다.";
        this.passCheck = false;
      }
      return this.passCheck;
    },
    async updateUser() {
      let returnData = [];
      if (!this.userId) {
        if (!this.idDuplication) {
          this.$bus.$emit("dialog", this.idText);
          return;
        }
        if (!this.passCheck) {
          this.$bus.$emit("dialog", this.passText);
          return;
        }
      }
      if (!this.checkPhoneNumber()) {
        return this.$bus.$emit(
          "dialog",
          "전화번호양식으로 입력해주세요.\n 예) 01012345678, 021234567"
        );
      }
      this.userDataList.phoneNumber = this.userDataList.phoneNumber.replaceAll(
        "-",
        ""
      );
      if (this.userDataList.userId) {
        if (this.userDataList.accountPassword)
          if (
            this.userDataList.accountPassword.length +
              this.userDataList.accountPasswordCheck.length !=
            0
          ) {
          }
        returnData = await UserApi.userModify(this.userDataList);
      } else {
        returnData = await UserApi.userRegister(this.userDataList);
      }
      let text = "";
      if (returnData.data.success == "ok") {
        text = "유저 등록에 성공하셨습니다.";
        this.$router.push({ name: "User" });
      } else {
        text = "유저 등록에 실패하였습니다. 확인 후 다시 시도해주세요.";
      }
      this.$bus.$emit("dialog", text);
    },
  },
};
</script>

<style scoped>
.width400-height38 {
  width: 400px;
  height: 38px;
}

.width-356 {
  width: 356px;
}

.padding-top50 {
  padding-top: 150px;
}

.color-556C96 {
  color: #556c96 !important;
}

.border-width-shrot {
  width: 250px;
  height: 42px;
  border: thin solid #aaaaaa;
}

.border-width {
  width: 356px;
  height: 42px;
  border: thin solid #aaaaaa;
}

.v-text-field--outlined >>> fieldset {
  border-color: #aaaaaa;
}
.width-200 {
  width: 200px;
}
.margin-left100 {
  margin-left: 100px;
}
.width-120 {
  width: 120px;
}
</style>
